export default __webpack_public_path__ + "static/media/clock.93faa4a9.svg";